export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8100.5c1e58c5.jpg";